const config = {
  baseURL: import.meta.env.VITE_API_URL,
  environment: import.meta.env.VITE_ENV,
  sentryDSN: import.meta.env.VITE_SENTRY_DSN,
};

export default config;
